export default __webpack_public_path__ + "images/eSIM.png";